import {
    ADD_NOTIFICATION,
    REMOVE_NOTIFICATION,
    FLUSH_NOTIFICATIONS,
    HIDE_NOTIFICATIONS_CENTER,
    SHOW_NOTIFICATIONS_CENTER,
} from '../constants/NotificationsActions';

export const pageSize = 10;

export function getDefaultDelay(notificationPayload) {
    switch (notificationPayload.state) {
        case 'success':
            return 3;
        case 'pending':
            return -1;
        default:
            return 10;
    }
}

export function generateNotification(params) {
    const notificationPayload = {
        id: params.id || Math.random().toString(32).slice(2),
        message: params.message,
        bulkName: params.bulkName || 'Général',
        state: params.state || 'pending',
    };
    notificationPayload.delay = params.delay
        || getDefaultDelay(notificationPayload) * 1000;
    return notificationPayload;
}

export function rawAddNotification(notificationPayload) {
    return {
        type: ADD_NOTIFICATION,
        payload: notificationPayload,
    };
}

export function addNotification(params) {
    const notificationPayload = generateNotification(params);
    return (dispatch) => {
        dispatch(rawAddNotification(notificationPayload));
        return notificationPayload.id;
    };
}

export function removeNotification(id) {
    return {
        type: REMOVE_NOTIFICATION,
        payload: {
            id,
        },
    };
}

export function flushNotifications() {
    return {
        type: FLUSH_NOTIFICATIONS,
    };
}

export function showNotificationsCenter() {
    return {
        type: SHOW_NOTIFICATIONS_CENTER,
    };
}

export function hideNotificationsCenter() {
    return {
        type: HIDE_NOTIFICATIONS_CENTER,
    };
}
